/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { CreatePersonalAccessTokenResponseData } from "./CreatePersonalAccessTokenResponseData";
export const CreatePersonalAccessTokenResponse = core.serialization.object({
    data: CreatePersonalAccessTokenResponseData,
});
